const actionTypes = {
	GET_TEMPLATES: 'GET_TEMPLATES',
	GET_TEMPLATES_SUCCESS: 'GET_TEMPLATES_SUCCESS',
	GET_TEMPLATES_FAILURE: 'GET_TEMPLATES_FAILURE',
	SELECTED_TEMPLATE: 'SELECTED_TEMPLATE',
	SET_SELECTED_LIST: 'SET_SELECTED_LIST',
	GET_PREVIEW: 'GET_PREVIEW',
	GET_PREVIEW_SUCCESS: 'GET_PREVIEW_SUCCESS',
	GET_PREVIEW_FAILURE: 'GET_PREVIEW_FAILURE',
	CLEAR_PREVIEW: 'CLEAR_PREVIEW',
	SET_FILTER_LIST: 'SET_FILTER_LIST',
	CLEAR_UNSELECTED_ITEMS_FILTERS: 'CLEAR_UNSELECTED_ITEMS_FILTERS',
	GET_ROW_COUNT: 'GET_ROW_COUNT',
	GET_ROW_COUNT_SUCCESS: 'GET_ROW_COUNT_SUCCESS',
	GET_ROW_COUNT_FAILURE: 'GET_ROW_COUNT_FAILURE',
	CLEAR_PREVIEWED_LOADED: 'CLEAR_PREVIEWED_LOADED',
	GET_REFRESH_TIME_SUCCESS: 'GET_REFRESH_TIME_SUCCESS',
	GET_REFRESH_TIME_FAILURE: 'GET_REFRESH_TIME_FAILURE',
	GET_REPORTS_LIST: 'GET_REPORTS_LIST',
	GET_REPORTS_LIST_SUCCESS: 'GET_REPORTS_LIST_SUCCESS',
	GET_REPORTS_LIST_FAILURE: 'GET_REPORTS_LIST_FAILURE',
	GET_SHARED_REPORTS_LIST: 'GET_SHARED_REPORTS_LIST',
	GET_SHARED_REPORTS_LIST_SUCCESS: 'GET_SHARED_REPORTS_LIST_SUCCESS',
	GET_SHARED_REPORTS_LIST_FAILURE: 'GET_SHARED_REPORTS_LIST_FAILURE',
	DOWNLOAD_REPORT: 'DOWNLOAD_REPORT',
	DOWNLOAD_LARGE_REPORT: 'DOWNLOAD_LARGE_REPORT',
	DOWNLOAD_REPORT_SUCCESS: 'DOWNLOAD_REPORT_SUCCESS',
	DOWNLOAD_REPORT_FAILURE: 'DOWNLOAD_REPORT_FAILURE',
	DOWNLOAD_LARGE_REPORT_SUCCESS: 'DOWNLOAD_LARGE_REPORT_SUCCESS',
	DOWNLOAD_LARGE_REPORT_FAILURE: 'DOWNLOAD_LARGE_REPORT_FAILURE',
	DELETE_REPORT: 'DELETE_REPORT',
	DELETE_REPORT_SUCCESS: 'DELETE_REPORT_SUCCESS',
	DELETE_REPORT_FAILURE: 'DELETE_REPORT_FAILURE',
	ADD_PREVIEW_COLUMN: 'ADD_PREVIEW_COLUMN',
	REMOVE_PREVIEW_COLUMN: 'REMOVE_PREVIEW_COLUMN',
	SET_PREV_SELECTED_LIST: 'SET_PREV_SELECTED_LIST',
	SET_PREV_FILTER_LIST: 'SET_PREV_FILTER_LIST',
	DRAFT_PREV_SELECTED_LIST: 'DRAFT_PREV_SELECTED_LIST',
	DRAFT_PREV_FILTER_LIST: 'DRAFT_PREV_FILTER_LIST',
	CLEAR_PREV_SELECTION: 'CLEAR_PREV_SELECTION',
	REFRESH_REPORTS_LIST: 'REFRESH_REPORTS_LIST',
	REFRESH_REPORTS_LIST_SUCCESS: 'REFRESH_REPORTS_LIST_SUCCESS',
	REFRESH_REPORTS_LIST_FAILURE: 'REFRESH_REPORTS_LIST_FAILURE',
	INITIATE_RUN_NOW: 'INITIATE_RUN_NOW',
	INITIATE_RUN_NOW_SUCCESS: 'INITIATE_RUN_NOW_SUCCESS',
	INITIATE_RUN_NOW_FAILURE: 'INITIATE_RUN_NOW_FAILURE',
	EDIT_REPORT: 'EDIT_REPORT',
	GET_REFRESH_TIME: 'GET_REFRESH_TIME',
	GET_FIRSTTIME_USR_STATUS: 'GET_FIRSTTIME_USR_STATUS',
	SET_FIRSTTIME_USR_STATUS: 'SET_FIRSTTIME_USR_STATUS',
	ERR_FIRSTTIME_USR_STATUS: 'ERR_FIRSTTIME_USR_STATUS',
	RESET_FIRSTTIME_USR_STATUS: 'RESET_FIRSTTIME_USR_STATUS',
	GET_CUSTOM_ATTRIBUTE: 'GET_CUSTOM_ATTRIBUTE',
	GET_CUSTOM_ATTRIBUTE_SUCCESS: 'GET_CUSTOM_ATTRIBUTE_SUCCESS',
	GET_CUSTOM_ATTRIBUTE_FAILURE: 'GET_CUSTOM_ATTRIBUTE_FAILURE',
	SET_MENU: 'SET_MENU',
	RESET_SCHEDULE_REPORT_ERROR: 'RESET_SCHEDULE_REPORT_ERROR',
	LOAD_PREVIEW_PAGE: 'LOAD_PREVIEW_PAGE',
	LOAD_TEMPLATE_ON_EDIT: 'LOAD_TEMPLATE_ON_EDIT',
	LOAD_PREVIEW_ON_EDIT: 'LOAD_PREVIEW_ON_EDIT',
	SET_TAB_VALUE: 'SET_TAB_VALUE',
	GET_USER_LIST: 'GET_USER_LIST',
	GET_USER_LIST_SUCCESS: 'GET_USER_LIST_SUCCESS',
	GET_USER_LIST_FAILURE: 'GET_USER_LIST_FAILURE',
	SET_INVITED_USERS: 'SET_INVITED_USERS',
	RESET_USERS_WITH_REPORT_ACCESS: 'RESET_USERS_WITH_REPORT_ACCESS',
	SET_USERS_WITH_REPORT_ACCESS: 'SET_USERS_WITH_REPORT_ACCESS',
	SET_USERS_WITH_REPORT_ACCESS_SUCCESS: 'SET_USERS_WITH_REPORT_ACCESS_SUCCESS',
	SET_USERS_WITH_REPORT_ACCESS_FAILURE: 'SET_USERS_WITH_REPORT_ACCESS_FAILURE',
	REMOVE_REPORT_ACCESS: 'REMOVE_REPORT_ACCESS',
	SET_USERS_TO_REMOVE_ACCESS: 'SET_USERS_TO_REMOVE_ACCESS',
	LEAVE_REPORT: 'LEAVE_REPORT',
	LEAVE_REPORT_SUCCESS: 'LEAVE_REPORT_SUCCESS',
	LEAVE_REPORT_FAILURE: 'LEAVE_REPORT_FAILURE',
	GET_SBU_DEPARTMENTS: 'GET_SBU_DEPARTMENTS',
	GET_SBU_DEPARTMENTS_SUCCESS: 'GET_SBU_DEPARTMENTS_SUCCESS',
	GET_SBU_DEPARTMENTS_FAILURE: 'GET_SBU_DEPARTMENTS_FAILURE',
	GET_SUB_TEMPLATE_DETAILS: 'GET_SUB_TEMPLATE_DETAILS',
	GET_SUB_TEMPLATE_DETAILS_SUCCESS: 'GET_SUB_TEMPLATE_DETAILS_SUCCESS',
	GET_SUB_TEMPLATE_DETAILS_FAILURE: 'GET_SUB_TEMPLATE_DETAILS_FAILURE',
	RESET_SUB_TEMPLATE_DETAILS: 'RESET_SUB_TEMPLATE_DETAILS',
	SET_IS_MANDATE_CHECK: 'SET_IS_MANDATE_CHECK',
	GET_CANNED_REPORTS: 'GET_CANNED_REPORTS',
	GET_CANNED_REPORTS_SUCCESS: 'GET_CANNED_REPORTS_SUCCESS',
	GET_CANNED_REPORTS_ERROR: 'GET_CANNED_REPORTS_ERROR',
	SET_LINK_ITEMS_ACTIVITY: 'SET_LINK_ITEMS_ACTIVITY',
	USER_CAN_CREATE_REPORT: 'USER_CAN_CREATE_REPORT',
	USER_CAN_CREATE_REPORT_SUCCESS: 'USER_CAN_CREATE_REPORT_SUCCESS',
	USER_CAN_CREATE_REPORT_FAILURE: 'USER_CAN_CREATE_REPORT_FAILURE',
	GET_MERCHANT_USER_LIST: 'GET_MERCHANT_USER_LIST',
	GET_MERCHANT_USER_LIST_SUCCESS: 'GET_MERCHANT_USER_LIST_SUCCESS',
	GET_MERCHANT_USER_LIST_FAILURE: 'GET_MERCHANT_USER_LIST_FAILURE',
	GET_DV_USER_LIST: 'GET_DV_USER_LIST',
	GET_DV_USER_LIST_SUCCESS: 'GET_DV_USER_LIST_SUCCESS',
	GET_DV_USER_LIST_FAILURE: 'GET_DV_USER_LIST_FAILURE',
	SET_HIERARCHY: 'SET_HIERARCHY',
	GET_SAVED_REPORTS_LIST: 'GET_SAVED_REPORTS_LIST',
	GET_SAVED_REPORTS_LIST_SUCCESS: 'GET_SAVED_REPORTS_LIST_SUCCESS',
	GET_SAVED_REPORTS_LIST_FAILURE: 'GET_SAVED_REPORTS_LIST_FAILURE',
	SET_REPORT_TYPE_TAB_VALUE: 'SET_REPORT_TYPE_TAB_VALUE',
	SAVE_DRAFT: 'SAVE_DRAFT',
	SAVE_DRAFT_SUCCESS: 'SAVE_DRAFT_SUCCESS',
	SAVE_DRAFT_FAILURE: 'SAVE_DRAFT_FAILURE',
	RESET_DRAFT: 'RESET_DRAFT',
	SET_REPORT_LIST_FILTER_VALUES: 'SET_REPORT_LIST_FILTER_VALUES',
	RESET_SAVED_DRAFT_STATUS: 'RESET_SAVED_DRAFT_STATUS',
	RESET_ROWCOUNT_OBJ: 'RESET_ROWCOUNT_OBJ',
	SET_PREVIEW_TOUR: 'SET_PREVIEW_TOUR',
	UPDATE_SAVED_REPORTS_LIST: 'UPDATE_SAVED_REPORTS_LIST',
	LOAD_PREVIEW_DATA: 'LOAD_PREVIEW_DATA',
	ITEM_SHARED_STATUS: 'ITEM_SHARED_STATUS',
	ITEM_SHARE_MANDATORY_SELECTION: 'ITEM_SHARE_MANDATORY_SELECTION',
	SEARCH_TXT: 'SEARCH_TXT',
	SORTBY: 'SORTBY',
	SORT_DIRECTION: 'SORT_DIRECTION',
	FILTER_BY: 'FILTER_BY',
	RESET_DASHBOARD_FILTER: 'RESET_DASHBOARD_FILTER',
	SET_SHARED_TAB_VALUE: 'SET_SHARED_TAB_VALUE',
	SET_PINNED_ATTRIBUTE: 'SET_PINNED_ATTRIBUTE',
	GET_PINNED_ATTRIBUTE: 'GET_PINNED_ATTRIBUTE',
	GET_PINNED_ATTRIBUTE_SUCCESS: 'GET_PINNED_ATTRIBUTE_SUCCESS',
	GET_PINNED_ATTRIBUTE_FAILURE: 'GET_PINNED_ATTRIBUTE_FAILURE',
	SAVE_PINNED_ATTRIBUTE: 'SAVE_PINNED_ATTRIBUTE',
	SAVE_PINNED_ATTRIBUTE_FAILURE: 'SAVE_PINNED_ATTRIBUTE_FAILURE',
	SET_PINNED_ATTRIBUTE_SNACKBAR: 'SET_PINNED_ATTRIBUTE_SNACKBAR',
	GET_CUSTOM_DATASET_DETAILS: 'GET_CUSTOM_DATASET_DETAILS',
	GET_CUSTOM_DATASET_DETAILS_SUCCESS: 'GET_CUSTOM_DATASET_DETAILS_SUCCESS',
	GET_CUSTOM_DATASET_DETAILS_FAILURE: 'GET_CUSTOM_DATASET_DETAILS_FAILURE',
	SAVE_CUSTOM_DATASET: 'SAVE_CUSTOM_DATASET',
	SAVE_CUSTOM_DATASET_SUCCESS: 'SAVE_CUSTOM_DATASET_SUCCESS',
	RESET_SAVE_SUCCESS_FLAG: 'RESET_SAVE_SUCCESS_FLAG',
	SET_DATASET_EXISTS_FLAG: 'SET_DATASET_EXISTS_FLAG',
	SAVE_CUSTOM_DATASET_FAILURE: 'SAVE_CUSTOM_DATASET_FAILURE',
	GET_SAVED_CUSTOM_DATASET: 'GET_SAVED_CUSTOM_DATASET',
	GET_SAVED_CUSTOM_DATASET_SUCCESS: 'GET_SAVED_CUSTOM_DATASET_SUCCESS',
	GET_SAVED_CUSTOM_DATASET_FAILURE: 'GET_SAVED_CUSTOM_DATASET_FAILURE',
	DELETE_CUSTOM_DATASET: 'DELETE_CUSTOM_DATASET',
	DELETE_CUSTOM_DATASET_SUCCESS: 'DELETE_CUSTOM_DATASET_SUCCESS',
	RESET_DELETE_DATASET_SUCCESS_FLAG: 'RESET_DELETE_DATASET_SUCCESS_FLAG',
	DELETE_CUSTOM_DATASET_FAILURE: 'DELETE_CUSTOM_DATASET_FAILURE',
	SET_CUSTOM_DATASET_TOUR: 'SET_CUSTOM_DATASET_TOUR',
	SET_IS_MTS_FILTER_COLLAPSED: 'SET_IS_MTS_FILTER_COLLAPSED',
	SET_REQUIRED_CHECK: 'SET_REQUIRED_CHECK',
	SET_PIVOT_COLUMN: 'SET_PIVOT_COLUMN',
	SET_CUSTOM_DATASET_NAME: 'SET_CUSTOM_DATASET_NAME',
	UPDATE_CUSTOM_DATASET: 'UPDATE_CUSTOM_DATASET',
	UPDATE_CUSTOM_DATASET_SUCCESS: 'UPDATE_CUSTOM_DATASET_SUCCESS',
	UPDATE_CUSTOM_DATASET_FAILURE: 'UPDATE_CUSTOM_DATASET_FAILURE',
	SET_PIVOT_OPTS: 'SET_PIVOT_OPTS',
	DRAFT_PREV_PIVOT_OPTION: 'DRAFT_PREV_PIVOT_OPTION',
	GET_VISUAL_HIERARCHY: 'GET_VISUAL_HIERARCHY',
	GET_VISUAL_HIERARCHY_SUCCESS: 'GET_VISUAL_HIERARCHY_SUCCESS',
	GET_VISUAL_HIERARCHY_FAILURE: 'GET_VISUAL_HIERARCHY_FAILURE',
	GET_START_AND_END_DATES: 'GET_START_AND_END_DATES',
	GET_START_AND_END_DATES_SUCCESS: 'GET_START_AND_END_DATES_SUCCESS',
	GET_START_AND_END_DATES_FAILURE: 'GET_START_AND_END_DATES_FAILURE'
};

export default actionTypes;
